import React, { useState, useEffect, useCallback } from "react";
import { push } from "connected-react-router";
import { useParams } from "react-router-dom";
import { Row, Col, Button } from "antd";
import { connect } from "react-redux";
import { useIntl } from "react-intl";

import {
  put,
  post,
  checkResponse,
  checkHttpStatus,
} from "../../../modules/httpFunctions";
import {
  loadCountries,
  loadPreselections,
} from "../../../modules/staticDataLoad";
import AddressForm from "../addressForm";
import LoadError from "../../app/generic/loadError";
import LoadSkeleton from "../../app/generic/loadSkeleton";
import { success, error } from "../../../modules/messages";
import { handleError } from "../../../modules/errorLogger";
import { getEntity } from "../../../modules/crudOperations";

function AddressBaseForm({ edit, push }) {
  const intl = useIntl();
  const formItemLayout = { colon: false };

  const { addressId } = useParams();
  const [address, setAddress] = useState();
  useEffect(() => {
    if (addressId) {
      getEntity("address", addressId, setLoading, setAddress);
    } else {
      setAddress({});
    }
  }, [addressId]);

  const [form, setForm] = useState();
  const saveFormRef = useCallback((formRef) => {
    setForm(formRef);
  }, []);

  const [countries, setCountries] = useState();
  const [preselections, setPreselections] = useState();
  const loadStaticFormData = useCallback(() => {
    loadCountries(setCountries);
    loadPreselections(setPreselections);
  }, []);

  const [loading, setLoading] = useState();
  const handleFormSubmit = useCallback(() => {
    setLoading(true);
    (form &&
      form.validateFields((err, values) => {
        values = { ...values, customer: true };
        (!err &&
          (edit ? put(`address/${addressId}`, values) : post("address", values))
            .then((r) => {
              setLoading(false);
              if (checkHttpStatus(r) && checkResponse(r)) {
                success(
                  intl.formatMessage({
                    id: "customer.saveSuccess",
                    defaultMessage: "Zákazník byl úspěšně uložen.",
                  })
                );
                push("/customers");
              } else {
                error(
                  intl.formatMessage({
                    id: "customer.saveError",
                    defaultMessage: "Při ukládání zákazníka nastala chyba!",
                  }),
                  10
                );
              }
            })
            .catch((err) => {
              setLoading(false);
              error(
                intl.formatMessage({
                  id: "customer.saveError",
                  defaultMessage: "Při ukládání zákazníka nastala chyba!",
                }),
                10
              );
              handleError(err);
            })) ||
          setLoading(false);
      })) ||
      setLoading(false);
  }, [intl, form, push, edit, addressId]);

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      handleFormSubmit();
    },
    [handleFormSubmit]
  );

  useEffect(() => {
    loadStaticFormData();
  }, [loadStaticFormData, intl.locale]);

  return (
    <Row type="flex" justify="center">
      <Col xxl={12} sm={18}>
        {countries && preselections && address ? (
          countries !== "e" && preselections !== "e" ? (
            address !== "e" ? (
              <Row>
                <Col>
                  <AddressForm
                    noColumns
                    showSearch
                    onlyAddress
                    address={address}
                    ref={saveFormRef}
                    countries={countries}
                    preselections={preselections}
                    formItemLayout={formItemLayout}
                  />
                  <Row>
                    <Col span={3}>
                      <Button
                        type="primary"
                        loading={loading}
                        onClick={handleSubmit}
                      >
                        {intl.formatMessage({
                          id: "customer.save",
                          defaultMessage: "Uložit zákazníka",
                        })}
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            ) : (
              <LoadError
                message={intl.formatMessage({
                  id: "customer.edit.try",
                  defaultMessage: "Zákazníka již není možné editovat!",
                })}
              />
            )
          ) : (
            <LoadError
              message={intl.formatMessage({
                id: "messages.formLoadError",
                defaultMessage: "Při načítání formuláře nastala chyba",
              })}
              onClick={loadStaticFormData}
            />
          )
        ) : (
          <LoadSkeleton />
        )}
      </Col>
    </Row>
  );
}

export default connect(null, { push })(AddressBaseForm);
